export const environment = {
    production: false,
    keycloakURL: "https://keycloak.tools.i9partner.com.br/realms/Ariel-dev",
    managerURL: "https://kong.dev.i9partner.com.br/ariel-manager-ms",
    consultasURL: "https://kong.dev.i9partner.com.br/ariel-consultas-ms",
    consultasSocketURL: "https://ariel-consultas.dev.i9partner.com.br",
    consultasSocketPath: "/ws/consultations",
    libraryURL: "https://kong.dev.i9partner.com.br/ariel-library-ms",
};
